module.exports = __webpack_public_path__ + "img/ListPlaceholderMobile.7a48ba06.svg";